import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

export const fetchHomePageData = createAsyncThunk(
    "homePage/fetchHomePageData",
    async (page, { rejectWithValue }) => {
        try {
            const response = await agent.get(`${API.CMS_PAGE}${page}`);
            return response.data?.data || {};
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchBrandData = createAsyncThunk(
    "brand/fetchBrandData",
    async (_, { rejectWithValue }) => {
        try {
            const response = await agent.get(API.BRAND);
            return response.data?.data || [];
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchLeaders = createAsyncThunk(
    "leaders/fetchLeaders",
    async (limit, { rejectWithValue }) => {
        try {
            const response = await agent.get(`${API.LEADER_DATA}?limit=${limit}`);
            return response.data?.data || [];
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const organisationSlice = createSlice({
    name: "organisation",
    initialState: {
        homePageData: {},
        brand: [],
        leaders: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchHomePageData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchHomePageData.fulfilled, (state, action) => {
                state.homePageData = action.payload;
                state.loading = false;
            })
            .addCase(fetchHomePageData.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchBrandData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchBrandData.fulfilled, (state, action) => {
                state.brand = action.payload;
                state.loading = false;
            })
            .addCase(fetchBrandData.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchLeaders.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchLeaders.fulfilled, (state, action) => {
                state.leaders = action.payload;
                state.loading = false;
            })
            .addCase(fetchLeaders.rejected, (state) => {
                state.loading = false;
            });
    },
});

export default organisationSlice.reducer;
